import * as React from 'react'
// libs
import { WrappedFieldArrayProps } from 'redux-form'
// components
import { ReduxAsyncPaginatedSelect } from 'components/FormElements/ReduxForm'
// views
import { Title, UserWrapper } from './views'
import { AddButton, CloseIcon } from 'components/Modals/SystemProcessModal/Form/components/views'
// types
import { IOption } from 'components/FormElements/Select'
import { GroupBase } from 'react-select'
// graphql
import { OWNED_BY_SELECT_QUERY } from 'graphql/plan/queries'
// utils
import { required } from 'utils/validators'
import { userAndPositionProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

interface Props {
  addLabel?: string
  prepareOptions: (options: (IOption & any)[]) => IOption[] | GroupBase<IOption>[]
}

const renderUsers: React.FC<WrappedFieldArrayProps<any> & Props> = ({ addLabel  = 'add user',  fields, prepareOptions }) => {
  const addField = () => fields.push({})

  const removeField = (idx: number) => () => fields.remove(idx)

  return (
    <>
      <Title>Available to these users:</Title>
      {fields.map((field, idx) => (
        <UserWrapper key={field}>
          <ReduxAsyncPaginatedSelect
            name={field}
            validate={required}
            menuPortalTarget={null}
            query={OWNED_BY_SELECT_QUERY}
            prepareOptions={prepareOptions}
            getOptions={userAndPositionProps.getOptions}
            filterKeys={[
              ['userFilter', 'name'],
              ['positionFilter', 'description']
            ]}
          />
          <CloseIcon data-testid='users-list-remove' data-entity-id={idx} onClick={removeField(idx)} />
        </UserWrapper>
      ))}

      <AddButton data-testid='users-list-add' onClick={addField}>
        + {addLabel}
      </AddButton>
    </>
  )
}

export default renderUsers
